export const USER_LOGGED_IN = 'USER_LOGGED_IN'
export const CONTENT_LOADED = 'CONTENT_LOADED'
export const TOKEN_REFRESHED = 'TOKEN_REFRESHED'
export const USER_LOGGED_OUT = 'USER_LOGGED_OUT'
